import React from 'react';
import { Customers, EntityType } from '../../../entity.types';
import { cleanObject, cleanResults } from '../chartTypologies.utils';
import {
  CompanySectorTypologiesPresentation,
  CompanySectorTypologiesChart,
} from '..';

type Props = {
  customers: Customers;
  decisionCount: number;
  entityType: EntityType;
  entityId: string;
  entityName: string;
};

type State = {
  sectorsData: Array<number>;
  sectorsLabels: Array<string>;
};

export class CompanySectorTypologies extends React.Component<Props, State> {
  state: State = {
    sectorsData: [],
    sectorsLabels: [],
  };

  componentDidMount() {
    const { enterpriseSectors } = cleanResults(this.props.customers);
    let sectorsData = null;
    let sectorsLabels = null;
    if (enterpriseSectors != null) {
      const cleanEnterpriseSectors = cleanObject(enterpriseSectors);
      sectorsData = cleanEnterpriseSectors.map((d) => Math.round(d[1]));
      sectorsLabels = cleanEnterpriseSectors.map((c) => c[0]);
      this.setState({ sectorsData, sectorsLabels });
    }
  }

  render() {
    const { decisionCount, entityType, entityName, entityId } = this.props;
    const { sectorsData, sectorsLabels } = this.state;
    const entityInfos = {
      decisionCount,
      entityType,
      entityName,
      entityId,
    };

    if (sectorsLabels.length === 0 || sectorsData.length === 0) {
      return null;
    }

    return (
      <CompanySectorTypologiesPresentation {...entityInfos}>
        <CompanySectorTypologiesChart
          sectorsLabels={sectorsLabels}
          sectorsData={sectorsData}
        />
      </CompanySectorTypologiesPresentation>
    );
  }
}
